import Vue from "vue";

export default {
	state: {
		supplier: {}
	},
	mutations: {
		setSupplierOnState(state, supplier) {
			state.supplier = supplier;
		}
	},
	actions: {
		getSupplier({ commit }, idUser) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("supplier/" + idUser)
					.then((response) => {
						this.state.loading = false;
						commit("setSupplierOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getSupplierBank(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("SupplierClientBank/" + data.idSupplier + "/" + data.idClient)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		deleteBankSupplier(_, idContact) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.delete("SupplierClientBank/" + idContact)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		addBankSupplier(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("SupplierClientBank/", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		updateSupplierClient(_, supplierClientObj) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("supplierClient/", supplierClientObj)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		supplierClientResetLogin(_, supplierClientObj) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("supplierClient/reset", supplierClientObj, { ignoreRefresh: true })
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		}
	},
	getters: {
		supplier({ supplier }) {
			return supplier;
		}
	}
};
